/**
 * 国械智造子站判断：以 `queryWebsiteByCompanyId` 返回的 `isGxzz`（1=是）为准。
 */

import { queryWebsiteByCompanyId } from '@/api/index.js';

/** 从已拉取的站点信息中判断是否国械智造 */
export function isGxzzFromWebsiteData(data) {
	return Number(data?.isGxzz) === 1;
}

/** 按 companyId 请求接口并判断（供 `useIsGxzzSite` / `useAsyncData` 使用） */
export async function fetchGxzzSiteByCompanyId(companyId) {
	if (companyId == null || companyId === '') return false;

	try {
		const res = await queryWebsiteByCompanyId(companyId);
		return isGxzzFromWebsiteData(res?.data);
	} catch (error) {
		console.error('[fetchGxzzSiteByCompanyId] queryWebsiteByCompanyId failed:', error);
		return false;
	}
}
